<template>
    <div class="d-block">
        <div class="logo-container mb-2">
            <div v-if="! value" class="empty-logo">
                Upload a logo
            </div>
            <img v-else :src="latestUrl" alt="Logo" style="max-width: 100%; max-height: 100%" />
        </div>
        <div>
            <spinner-button
                :busy="busy"
                @click="selectFile"
                variant="success"
            >Select File</spinner-button>
            <b-btn v-if="value" @click="clear" variant="secondary">Clear</b-btn>
        </div>
        <input ref="file" type="file" id="upload" class="d-none" accept="image/*" @change="upload()" />
    </div>
</template>

<script>
    import SpinnerButton from '../ui/SpinnerButton'
    export default {
      components: {SpinnerButton},
      props: {
            value: {
                type: String,
                required: true,
                default: '',
            },
            url: {
                type: String,
                required: false,
                default: '',
            }
        },

        data() {
            return {
                busy: false,
                latestUrl: '',
            }
        },

        methods: {
            selectFile() {
                this.$refs.file.click();
            },

            clearFile() {
                document.getElementById('upload').value = '';
            },

            clear() {
                this.$emit('input', '');
                this.clearFile();
            },

            upload() {
                let file = this.$refs.file.files[0];
                if (! file) {
                    return;
                }

                this.busy = true;
                let form = new Form({'image': file});
                form.alertOnSuccess = false;
                form.submit('POST', '/business/carriers/upload-logo', true)
                    .then( ({ data }) => {
                        console.log('response:', data);
                        this.latestUrl = data.data.url;
                        this.$emit('input', data.data.filename);
                    })
                    .catch(e => {})
                    .finally(() => {
                        this.busy = false;
                        this.clearFile();
                    })
            },
        },

        mounted() {
            this.latestUrl = this.url;
        },
    }
</script>

<style>
    .empty-logo { border: 1px dashed grey; padding: 25px; text-align: center }
</style>
